// states/useLeagueTableState.js
import { useState } from "react";

export const useLeagueTableState = () => {
  const [leagueTableData, setLeagueTableData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTeams, setFilteredTeams] = useState([]);
  const [tableName, setTableName] = useState("");
  const [tableKey, setTableKey] = useState("");
  const [tableHeadings, setTableHeadings] = useState({});
  const [statColumnNumbers, setStatColumnNumbers] = useState([]);
  const [retryKey, setRetryKey] = useState(0);
  const [recentResults, setRecentResults] = useState([]);
  const [filteredRecentResults, setFilteredRecentResults] = useState([]);
  const [groupedResults, setGroupedResults] = useState({});
  const [resultsSearchTerm, setResultsSearchTerm] = useState("");
  const [resultsLoading, setResultsLoading] = useState(false);
  const [resultsError, setResultsError] = useState(null);
  const [upcomingMatches, setUpcomingMatches] = useState([]);
  const [filteredUpcomingMatches, setFilteredUpcomingMatches] = useState([]);
  const [groupedUpcomingMatches, setGroupedUpcomingMatches] = useState({});
  const [upcomingSearchTerm, setUpcomingSearchTerm] = useState("");
  const [matchesLoading, setMatchesLoading] = useState(false);
  const [matchesError, setMatchesError] = useState(null);
  const [activeTab, setActiveTab] = useState("leagueTable");
  const [sortConfig, setSortConfig] = useState({
    key: 'position',
    direction: 'asc'
  });

  return {
    leagueTableData,
    setLeagueTableData,
    loading,
    setLoading,
    error,
    setError,
    searchTerm,
    setSearchTerm,
    filteredTeams,
    setFilteredTeams,
    tableName,
    setTableName,
    tableKey,
    setTableKey,
    tableHeadings,
    setTableHeadings,
    statColumnNumbers,
    setStatColumnNumbers,
    retryKey,
    setRetryKey,
    recentResults,
    setRecentResults,
    filteredRecentResults,
    setFilteredRecentResults,
    groupedResults,
    setGroupedResults,
    resultsSearchTerm,
    setResultsSearchTerm,
    resultsLoading,
    setResultsLoading,
    resultsError,
    setResultsError,
    upcomingMatches,
    setUpcomingMatches,
    filteredUpcomingMatches,
    setFilteredUpcomingMatches,
    groupedUpcomingMatches,
    setGroupedUpcomingMatches,
    upcomingSearchTerm,
    setUpcomingSearchTerm,
    matchesLoading,
    setMatchesLoading,
    matchesError,
    setMatchesError,
    activeTab,
    setActiveTab,
    sortConfig,
    setSortConfig,
  };
};